import styled from 'styled-components';

export const AnswerDrawViewImage = styled.div`
  position: relative;
`;
